module.exports = __webpack_public_path__ + "img/cake.5bba7cde.png";